import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { AnalyticsService, Modal, ModalService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import FeatureBlockV25 from 'build-and-quote/components/Summary/components/VehicleCharacteristics/components/FeatureBlockV25.jsx';

import 'build-and-quote/components/Summary/components/VehicleCharacteristics/VehicleCharacteristics.scss';

const MODAL = 'widget/SummarySection';
const STYLES = {
    overlay: {
        zIndex: 2147483643,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        background: '#fff',
        overflowY: 'auto',
    },
};

class VehicleCharacteristics extends React.Component {
    constructor(props) {
        super(props);

        this.modal = ModalService.get(MODAL);
        this.renderStandardFeatures = this.renderStandardFeatures.bind(this);
        this.onOpenModal = this.onOpenModal.bind(this);
    }

    onOpenModal() {
        AnalyticsService.gaTrigger(TAGS.SPECS_SEE_ALL(this.props.selectedModel));
        this.modal.open();
    }

    renderStandardFeatures(standardFeatures) {
        if (!standardFeatures && isEmpty(standardFeatures)) {
            return null;
        }

        return standardFeatures?.map((feature) => {
            return (
                <li className="features-bloc">
                    <div className="features-bloc--content">{feature}</div>
                </li>
            );
        });
    }

    render() {
        const { selectedPackage, trim, configuration, isDoubleColumnLayout, options } = this.props;
        const { modelTrimFeatures, packageFeatures } = configuration || {};
        const blockClasses = ['car-features'];
        if (isDoubleColumnLayout) {
            blockClasses.push('is-double');
        }
        const featuresOnCard =
            modelTrimFeatures && modelTrimFeatures?.length > 0
                ? modelTrimFeatures
                : options.slice(0, Math.min(10, options.length)).map((option) => ({ description: option }));

        return (
            <div className={blockClasses.join(' ')}>
                <h2 className="features-title sr-subtitle-2">{LocaleService.t('summarySection.features_title')}</h2>
                {packageFeatures?.length > 0 && (
                    <FeatureBlockV25 features={packageFeatures} packageName={selectedPackage} />
                )}
                <div>
                    <FeatureBlockV25 features={featuresOnCard} packageName={trim} />
                    {options?.length > 0 && (
                        <button className="sr-link" onClick={this.onOpenModal}>
                            {LocaleService.t('summarySection.seeAllFeatures')}
                        </button>
                    )}
                </div>
                <Modal name={MODAL} contentLabel="features section dialog" style={STYLES}>
                    <div className="style-specs__modal-close-bloc">
                        <button className="modal-close icon-showroom" onClick={this.modal.close} />
                    </div>
                    <div className="style-specs__modal car-equipments_summary is-scrollable">
                        <ul className="car-equipments_summary-list">{this.renderStandardFeatures(options)}</ul>
                    </div>
                </Modal>
            </div>
            // )
        );
    }
}

VehicleCharacteristics.defaultProps = {
    isDoubleColumnLayout: false,
    options: [],
};

VehicleCharacteristics.propTypes = {
    selectedPackage: PropTypes.string.isRequired,
    trim: PropTypes.string.isRequired,
    configuration: PropTypes.shape({
        modelTrimFeatures: PropTypes.arrayOf(PropTypes.object).isRequired,
        modelTrimStandardFeatures: PropTypes.arrayOf(PropTypes.object).isRequired,
        packageFeatures: PropTypes.arrayOf(PropTypes.object),
        packageStandardFeatures: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
    isDoubleColumnLayout: PropTypes.bool,
    selectedModel: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
};

VehicleCharacteristics.displayName = 'VehicleCharacteristics';

export default VehicleCharacteristics;
